import { render } from "./Embed.vue?vue&type=template&id=a26a44a6"
import script from "./Embed.vue?vue&type=script&lang=js"
export * from "./Embed.vue?vue&type=script&lang=js"
script.render = render

export default script